import { render } from "./CookiesPopup.vue?vue&type=template&id=306df5de&scoped=true"
import script from "./CookiesPopup.vue?vue&type=script&lang=js"
export * from "./CookiesPopup.vue?vue&type=script&lang=js"

import "./CookiesPopup.vue?vue&type=style&index=0&id=306df5de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306df5de"]])

export default __exports__